import React, { useMemo } from 'react';
import MultiSelectAvatar from './MultiSelectAvatar';
import { useSelector, useDispatch } from 'react-redux';
import { scoutGroupSelection } from '../../../actions/scout-kanban';
// import { compareTwo } from '../utils';

const ScoutSelection = () => {
    const dispatch = useDispatch();
    const columns = useSelector((state) => state.scoutKanban.columns);
    const sgList = useSelector((state) => state.scoutKanban.sgList);
    const sgListById = useSelector((state) => state.scoutKanban.sgListById);
    const isRequestingScoutGroupList = useSelector((state) => state.scoutKanban.isRequestingScoutGroupList)
    const selected = columns.filter(e => e.scoutGroupId !== null).map(e => e.scoutGroupId);
    const changedCrews = Object.keys(sgListById).filter(crewId =>
        crewId && sgListById[crewId] && sgListById[crewId].hasOwnProperty("isChanged") ? sgListById[crewId].isChanged : false);

    const onSelect = (item, checked) => {
        const selectedOpt = [...selected];
        if (checked) selectedOpt.push(item.id);
        else selectedOpt.splice(selectedOpt.indexOf(item.id), 1);
        dispatch(scoutGroupSelection(selectedOpt));

        // const { added } = compareTwo(selected, selectedOpt);
        // if (added.length > 0 && !sgListById.hasOwnProperty(item.id)) actions.getCrewInfo(added);
    };

    const list = useMemo(() => {
        if (sgList && sgList.length > 0) {
            const groupList = sgList.map((list) => {
                const id = list.scout_group_uuid;
                const name = sgListById.hasOwnProperty(id) ? sgListById[id].scout_group_name : list.scout_group_name;
                return ({ scout_group_uuid: id, scout_group_name: name });
            })
            return groupList;
        }
        return []
    }, [sgList])
    return (
        <div className={`kanban-filter ${isRequestingScoutGroupList ? "event-disabled" : ""}`}>
            <MultiSelectAvatar
                className="multi-select-avatar"
                options={list.map(e => ({ id: e.scout_group_uuid, label: e.scout_group_name }))}
                selected={selected}
                disabled={changedCrews}
                onSelect={onSelect}
                maxDisplay={6}
                maxSelection={5}
            />
        </div >
    )
}

export default ScoutSelection